import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	httpSubmitVisualVettingListing,
	type SubmitVisualVettingListingOptions
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { FINAL_REVIEW_LISTINGS_QUERY_KEY } from './use-get-final-review-listings'
import { QUEUE_COUNTS_QUERY_KEY } from './use-get-queue-counts'
import { VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY } from './use-get-visual-vetting-listing-details'
import { VISUAL_VETTING_LISTINGS_QUERY_KEY } from './use-get-visual-vetting-listings'

export const useSubmitVisualVettingListing = (
	listingId: string,
	options?: Omit<
		UseMutationOptions<
			unknown,
			unknown,
			SubmitVisualVettingListingOptions['payload']
		>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload) =>
			httpSubmitVisualVettingListing({
				urlParams: { listingId },
				payload
			}),
		...options,
		onSuccess: (...args) => {
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [FINAL_REVIEW_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [
					VISUAL_VETTING_LISTING_DETAILS_QUERY_KEY,
					{ listingId }
				]
			})
			queryClient.invalidateQueries({
				queryKey: [QUEUE_COUNTS_QUERY_KEY]
			})
			options?.onSuccess?.(...args)
		},
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
}
